"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceAmountModalContent = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const i18n_1 = require("../../i18n");
const insurance_amount_modal_content_constants_1 = require("./insurance-amount-modal-content.constants");
const insurance_amount_modal_content_styles_1 = require("./insurance-amount-modal-content.styles");
const InsuranceAmountModalContent = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const events = (0, insurance_amount_modal_content_constants_1.getEvents)(t);
    return (react_1.default.createElement(insurance_amount_modal_content_styles_1.ModalContent, null,
        react_1.default.createElement(insurance_amount_modal_content_styles_1.ModalHeaderWrapper, null,
            react_1.default.createElement(insurance_amount_modal_content_styles_1.StyledModalTitle, { title: t('SMART:CoverageSum.modalTitle', {
                    defaultValue: i18n_1.i18nDefaultValues.CoverageSum.modalTitle,
                }) })),
        react_1.default.createElement("div", null, t('SMART:CoverageSum.hints.amount', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.hints.amount,
        })),
        react_1.default.createElement("div", null, t('SMART:CoverageSum.hints.recomendations', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.hints.recomendations,
        })),
        react_1.default.createElement("div", null, t('SMART:CoverageSum.hints.example', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.hints.example,
        })),
        react_1.default.createElement(insurance_amount_modal_content_styles_1.List, null,
            react_1.default.createElement(insurance_amount_modal_content_styles_1.ListTitleRow, null,
                react_1.default.createElement(insurance_amount_modal_content_styles_1.ListTitle, null, t('SMART:CoverageSum.events.title', {
                    defaultValue: i18n_1.i18nDefaultValues.CoverageSum.events.title,
                })),
                react_1.default.createElement(insurance_amount_modal_content_styles_1.ListAmount, null, t('SMART:CoverageSum.events.amount', {
                    defaultValue: i18n_1.i18nDefaultValues.CoverageSum.events.amount,
                }))),
            events.map(({ title, payments, amount }) => (react_1.default.createElement(insurance_amount_modal_content_styles_1.Row, { key: title },
                react_1.default.createElement(insurance_amount_modal_content_styles_1.Title, null, title),
                react_1.default.createElement(insurance_amount_modal_content_styles_1.AmountWrapper, null,
                    react_1.default.createElement(insurance_amount_modal_content_styles_1.Payments, null, payments),
                    react_1.default.createElement(insurance_amount_modal_content_styles_1.Amount, null, amount)))))),
        react_1.default.createElement("div", null, t('SMART:CoverageSum.hints.other', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.hints.other,
        })),
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_i18next_1.Trans, { values: {
                    href: 'https://www.rgs.ru/about/dokumenty/pravila-strakhovaniya-i-strakhovye-tarify?doccode=258',
                }, components: { a: react_1.default.createElement(insurance_amount_modal_content_styles_1.TextLink, null) } }, t('SMART:CoverageSum.hints.full', {
                defaultValue: i18n_1.i18nDefaultValues.CoverageSum.hints.full,
            })))));
};
exports.InsuranceAmountModalContent = InsuranceAmountModalContent;
